import React from 'react';

import Button from 'widgets/Button';

export default function CouponsEmptyState() {
  return (
    <div className="gn-content cou-emptyState">
      <div className="cou-emptyState__msgWrapper">
        <h5 className="cou-emptyState__msgTitle">
          No coupons
        </h5>
        <p className="cou-emptyState__msgText">
          Check back soon for your next batch of coupons.
        </p>
      </div>
      <div className="cou-emptyState__actionWrapper">
        <p className="cou-emptyState__actionText">
          View our current offers for more fantastic savings.
        </p>
        <Button
          className="cou-emptyState__action"
          to="/on-offer"
        >
          See offers
        </Button>
      </div>
    </div>
  );
}
